<template lang="html">
  <section class="demo">

    <div style="width: 100%; display: flex; flex-direction: column">
      <h4>New Conversation Screen</h4>

      <p>
        <span>Clicking the&nbsp;</span>
        <span style="background-color: #e6e6e6; font-weight: 400; padding-left: 4px; padding-right: 4px;">New
          Conversation</span>
        <span>&nbsp;button will bring you to the New Conversation Screen.</span>
      </p>

      <p>
        In this screen, you will be shown a list of contacts, retrieved from your phone’s contact list, and
        cross-checked against the application’s database for users who are also using the app (matching mobile number in
        e.164 format)
      </p>

      <div>
        <div style="margin-bottom: 16px;">There are two types of contact:</div>

        <ul class="Vlt-list Vlt-list--simple">
          <li>
            <div>
              <div>App User Contact</div>
              <img src="https://vids.vonage.com/pages/inapp-android/image7.jpg" width="240" alt="image7" />
            </div>
          </li>
          <li>
            <div>Non-App User Contact</div>
            <img src="https://vids.vonage.com/pages/inapp-android/image8.jpg" width="240" alt="image8" />
          </li>
        </ul>
      </div>
    </div>

    <div style="display: flex; flex-direction: row; width: 100%;">
      <div style="display: flex; flex: 1; flex-direction: column;">
        <p>Clicking on an App User Contact, will start a chat conversation, showing you the chat screen (similar to
          other chat applications in the market).</p>

        <p>However, clicking on a Non-App User Contact, you will be shown a dialog, which you can choose to call the
          user via PSTN or SIP (more about SIP in the coming sections).</p>
      </div>

      <img src="https://vids.vonage.com/pages/inapp-android/image9.jpg" width="240" alt="image9" />
    </div>


  </section>

</template>

<script lang="js">
export default {
  name: 'demo',
  components: {
  },
  props: {
    nexmo: {
      type: Object,
      required: false
    }
  },
}
</script>

<style scoped lang="scss"></style>